import { useCallback, useState } from 'react'
import { Badge, Button, Card, Col, Collapse, Container, Table } from 'react-bootstrap'
import Avatar from '../components/common/Avatar'
import { useAuth } from '../contexts/auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useToasts } from '../contexts/toasts';
import { Authentication } from '../api/Authentication';
import Cookies from 'js-cookie';
import keycloak from '../keycloak';
import IconButton from '../components/common/IconButton';

export default function Account() {
  const { loggedUser, token, setToken } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { showToast } = useToasts();

  const toggleChangePassword = useCallback(() => setShowChangePassword(v => !v), []);

  const handleRefreshToken = useCallback(() => {
    Authentication.refreshToken()
      .then(
        ({ data: tokenInfo }) => {
          setToken(tokenInfo.access_token);
          Cookies.set(window.__env.AUTH_TOKEN_NAME || "alida-token", tokenInfo.access_token, { expires: tokenInfo.expires_in });
          Cookies.set(window.__env.AUTH_REFRESH_TOKEN_NAME || "alida-refresh-token", tokenInfo.refresh_token, { expires: tokenInfo.refresh_expires_in });
          showToast('refresh-token-success', "Token refreshed successfully", "Refresh Token Success", 'success');
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          console.log("Error refreshing token:", status, message);
          showToast('refresh-token-error', message, `Refresh Token Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [setToken, showToast]);

  const handleTokenCopy = useCallback(() => {
    navigator.clipboard.writeText(token!);
    showToast("token-copy", "Token copied to clipboard");
  }, [token, showToast]);

  const changePassword = useCallback(() => keycloak.login({ action: "UPDATE_PASSWORD" }), []);

  return loggedUser ? (
    <Container className="mt-3">
      <Card className="mb-3">
        <Card.Body>
          <div className="d-flex align-items-center mb-3">
            <Avatar user={loggedUser} />
            <Col className="ms-2">
              <h5 className="mb-0">{loggedUser.preferred_username}</h5>
              <h6 className="text-muted mb-0">{loggedUser.email}</h6>
            </Col>
            <Button variant="light" className="ms-auto border" size="sm" onClick={handleRefreshToken}>
              <FontAwesomeIcon icon={solid('arrows-rotate')} />
              <span className="ms-2">Refresh user token</span>
            </Button>
            <Button variant="light" className="ms-3 border" size="sm" onClick={handleTokenCopy}>
              <FontAwesomeIcon icon={regular('clipboard')} />
              <span className="ms-2">Copy user token</span>
            </Button>
          </div>

          <Table>
            <thead>
              <tr>
                <th style={{ width: '40%' }}></th>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="col">Name</th>
                <td className="text-end">{loggedUser.name}</td>
              </tr>
              <tr>
                <th scope="col">Organization</th>
                <td className="text-end">{loggedUser.organizationName}</td>
              </tr>
              {loggedUser.groups && (
                <tr>
                  <th scope="col">Groups</th>
                  <td className="text-end">{loggedUser.groups.map((group, index) => <Badge key={index} className="me-2">{group}</Badge>)}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="p-1">
          <button className="d-block w-100 text-start toggle-button" onClick={toggleChangePassword}>
            <FontAwesomeIcon icon={solid('key')} />
            <span className="ms-2">Change Password</span>
          </button>

          <Collapse in={showChangePassword}>
            <div>
              <div className="p-3 text-center">
                If you want to set a new password <IconButton className="p-0 fw-bold text-primary" onClick={changePassword}>click here</IconButton>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    </Container>
  ) : null;
}
